module.exports = __webpack_public_path__ + "img/hakhak.22498c8d.png";